/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceChallengeZoneMoreActivation
 */
export interface SurfaceChallengeZoneMoreActivation {
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneMoreActivation
     */
    logoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneMoreActivation
     */
    brandName: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneMoreActivation
     */
    type: string;
}

/**
 * Check if a given object implements the SurfaceChallengeZoneMoreActivation interface.
 */
export function instanceOfSurfaceChallengeZoneMoreActivation(value: object): value is SurfaceChallengeZoneMoreActivation {
    if (!('brandName' in value) || value['brandName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function SurfaceChallengeZoneMoreActivationFromJSON(json: any): SurfaceChallengeZoneMoreActivation {
    return SurfaceChallengeZoneMoreActivationFromJSONTyped(json, false);
}

export function SurfaceChallengeZoneMoreActivationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceChallengeZoneMoreActivation {
    if (json == null) {
        return json;
    }
    return {
        
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'brandName': json['brandName'],
        'type': json['type'],
    };
}

export function SurfaceChallengeZoneMoreActivationToJSON(json: any): SurfaceChallengeZoneMoreActivation {
    return SurfaceChallengeZoneMoreActivationToJSONTyped(json, false);
}

export function SurfaceChallengeZoneMoreActivationToJSONTyped(value?: SurfaceChallengeZoneMoreActivation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logoUrl': value['logoUrl'],
        'brandName': value['brandName'],
        'type': value['type'],
    };
}

